/* All CTAs share one human contact endpoint. No tracking or automatic sends. */
(() => {
  'use strict';
  const root=document.getElementById('noclen-contact'); if(!root||root.dataset.ready)return;
  root.dataset.ready='1';
  const buy=document.getElementById('noclen-buy');
  if(buy&&'IntersectionObserver' in window)new IntersectionObserver(entries=>root.classList.toggle('ncc--buy',entries[0].isIntersecting)).observe(buy);
  const button=root.querySelector('[data-ncc-toggle]');
  const panel=root.querySelector('#ncc-panel');
  const title=root.querySelector('#ncc-title');
  const description=root.querySelector('#ncc-description');
  const links=Array.from(root.querySelectorAll('[data-nc-contact-channel]'));
  const bases=new Map(links.map(link=>[link,link.getAttribute('href')]));
  const defaults={title:root.dataset.defaultTitle,message:root.dataset.defaultMessage,description:'Message me directly.'};
  const intents={
    question:defaults,
    'support-group':{title:'Join the support group',message:"Hey Reuben, I'd like to join your eczema support group.",description:'Choose how to message Reuben for an invite.'},
    ebook:{title:'Get the eczema guide',message:"Hey Reuben, I'd like your eczema guide.",description:'Choose how to message Reuben for the guide.'}
  };
  let returnFocus=button;
  function configure(intent,options){
    const selected=intents[intent]||defaults;
    const text=Object.assign({},selected);
    ['title','message','description'].forEach(key=>{if(options&&typeof options[key]==='string'&&options[key].trim())text[key]=options[key].trim().slice(0,500)});
    title.textContent=text.title;description.textContent=text.description;
    links.forEach(link=>{
      const base=bases.get(link),channel=link.dataset.ncContactChannel;
      if(channel==='whatsapp'){const url=new URL(base);url.searchParams.set('text',text.message);link.href=url.href}
      else if(channel==='sms'){link.setAttribute('href',base.split('?')[0]+'?&body='+encodeURIComponent(text.message))}
      else if(channel==='email'){const url=new URL(base);url.searchParams.set('subject',intent==='question'?'Question about Noclen':text.title);url.searchParams.set('body',text.message);link.href=url.href}
    });
    root.dataset.contactIntent=intent;
  }
  function open(intent='question',options={},origin=button){
    returnFocus=origin instanceof HTMLElement&&origin.isConnected?origin:button;
    configure(intent,options);panel.hidden=false;root.dataset.open='true';button.setAttribute('aria-expanded','true');
    const first=panel.querySelector('a')||panel.querySelector('button');if(first)first.focus({preventScroll:true});
    document.dispatchEvent(new CustomEvent('noclen:contact-open',{detail:{intent}}));
  }
  function close(restore=true){panel.hidden=true;root.dataset.open='false';button.setAttribute('aria-expanded','false');if(restore)returnFocus.focus({preventScroll:true})}
  button.addEventListener('click',()=>panel.hidden?open():close());
  root.querySelector('[data-ncc-close]').addEventListener('click',()=>close());
  document.addEventListener('click',event=>{
    const trigger=event.target.closest('[data-noclen-contact-intent],[data-nc-support-open]');
    if(trigger){event.preventDefault();open(trigger.dataset.noclenContactIntent||'support-group',{
      title:trigger.dataset.noclenContactTitle,message:trigger.dataset.noclenContactMessage,description:trigger.dataset.noclenContactDescription
    },trigger);return}
    if(!panel.hidden&&!root.contains(event.target))close(false);
  });
  document.addEventListener('keydown',event=>{
    if(event.key==='Escape'&&!panel.hidden){event.preventDefault();close()}
    if(event.key==='Tab'&&!panel.hidden){
      const items=Array.from(panel.querySelectorAll('a,button')).filter(node=>!node.disabled);
      const first=items[0],last=items[items.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus({preventScroll:true})}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus({preventScroll:true})}
    }
  });
  window.NoclenContact=Object.freeze({open,close});
})();
